export default "/assets/images/smiling-face-with-smiling-eyes.d23422f528e2b705.png";